import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { hitApi } from "../../components/commonAction";
import appConfig from "../../config/appConfig";

export default function CheckoutReturn({ pageTitle }) {
    const [latestStatus, setLatestStatus] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const tick = () => {
            if (cancelled) return;
            hitApi({ url: "billing/me/transactions?limit=1", method: "GET", data: {}, alert: false }, (resp) => {
                if (cancelled) return;
                const latest = resp?.data?.transactions?.[0];
                if (latest) setLatestStatus(latest.status);
            });
        };
        tick();
        const t = setInterval(tick, 4000);
        return () => { cancelled = true; clearInterval(t); };
    }, []);

    return (
        <div className="pxl-public-shell">
            <Helmet><title>{pageTitle}</title></Helmet>
            <header className="pxl-public-header">
                <Link to="/">
                    <img src={appConfig.appLogo} alt={appConfig.appName} />
                </Link>
            </header>

            <div className="pxl-checkout-shell">
                <div className="pxl-checkout-card">
                    <div className="pxl-public-message">
                        <h2>Thanks — we're processing your payment</h2>
                        <p>
                            PayPal has accepted your approval. Your account will be updated as soon as
                            PayPal confirms the payment (usually within a minute).
                        </p>
                    </div>

                    {latestStatus === "completed" ? (
                        <div className="pxl-status-banner pxl-status-banner--success">
                            Payment confirmed. Your access is live.
                        </div>
                    ) : latestStatus === "failed" ? (
                        <div className="pxl-status-banner pxl-status-banner--danger">
                            The most recent payment attempt failed. Try again or contact support.
                        </div>
                    ) : (
                        <div className="pxl-status-banner pxl-status-banner--info">
                            Status: <code style={{ marginLeft: 4 }}>{latestStatus || "checking…"}</code>
                        </div>
                    )}

                    <div className="pxl-checkout-actions" style={{ justifyContent: "center", marginTop: 8 }}>
                        <Link to="/account/entitlements" className="pxlCommon-btn">Go to my entitlements</Link>
                        <Link to="/account/transactions" className="pxl-checkout-cancel-link">View transactions</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
